import { render, staticRenderFns } from "./taskNotify.vue?vue&type=template&id=52d8c428&scoped=true"
import script from "./taskNotify.vue?vue&type=script&lang=js"
export * from "./taskNotify.vue?vue&type=script&lang=js"
import style0 from "./taskNotify.vue?vue&type=style&index=0&id=52d8c428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d8c428",
  null
  
)

export default component.exports